<template>
  <div class="card card-custom gutter-b example example-compact">
    <soha-page-loading v-if="loading" />
    <div v-else>
      <div class="row m-0 soha-page-title">
        <label>
          {{ $t(`${I18nPrefix}PAGE_TITLE`) }}
        </label>
      </div>
      <soha-page-loading size="18" v-if="resumeLoading" />
      <soha-no-data
        v-if="resumes.length === 0"
        :message="$t(`${I18nPrefix}NO_DATA`)"
      />
      <div v-else>
        <div class="row m-0">
          <div
            class="col-lg-6 col-md-6 col-sm-12 col-12 py-2"
            v-for="resume in resumes"
            :key="resume.id"
          >
            <soha-resume-card :resume-data="resume" />
          </div>
        </div>
        <div class="py-2">
          <b-pagination
            v-if="totalResumeCount > perPage && !loading"
            v-model="currentPage"
            @input="goToPage"
            :total-rows="totalResumeCount"
            :per-page="perPage"
            align="center"
            pills
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SohaResumeCard from "@/view/components/resume/ResumeCard";
import UIMixin from "@/mixins/UIMixin";
import ApiService from "@/core/services/api.service";
export default {
  name: "Search",

  mixins: [UIMixin],

  components: { SohaResumeCard },

  data() {
    return {
      I18nPrefix: "PAGES.RESUME.RESUME_SEARCH.",
      loading: false,
      resumeLoading: false,
      currentPage: this.$route.query.page ? this.$route.query.page : 1,
      resumes: [],
      totalResumeCount: null,
      perPage: null,
    };
  },

  mounted() {
    this.getResumes();
  },

  methods: {
    getResumes() {
      if (!this.searchQuery) return;
      this.loading = true;
      ApiService.get("api/v2/resumes", {
        page: this.currentPage,
        keyword: this.searchQuery,
        searchKey: this.searchType,
      }).then(({ data }) => {
        if (data) {
          this.resumes = data.data;
          this.perPage = data.per_page;
          this.totalResumeCount = data.total;
          this.resumes.map((item) => {
            let firstName = item.firstName ?? "";
            let lastName = item.lastName ?? "";
            return (item.fullName = firstName + " " + lastName);
          });
        } else {
          this.errorToast(data.message);
        }
        this.loading = false;
      });
    },

    goToPage() {
      let query = Object.assign({}, this.$route.query);
      query.page = this.currentPage;
      this.$router.push({ query: query });
      this.getResumes(this.activeJob);
    },
  },

  watch: {
    searchQuery(newItem) {
      if (newItem) {
        this.currentPage = 1;
        this.getResumes();
      }
    },

    searchType(newItem, oldItem) {
      if (newItem && newItem != oldItem) {
        this.currentPage = 1;
        this.getResumes();
      }
    }
  },
  computed: {
    searchQuery() {
      return this.$route.query.searchKey;
    },

    searchType() {
      return this.$route.query.searchType;
    },
  },
};
</script>

<style scoped>
.soha-page-title {
  color: var(--primary-color);
  font-weight: bold;
  padding: 2.308rem 2.308rem 0.769rem 0;
}
</style>
